export const MiningSmithingRecipesPanel = ({
  smithing,
  smithingBusyKey,
  boostBusyKey,
  onCraft,
  onActivateBoost,
  sectionId,
}) => {
  const materials = smithing?.materials || [];

  return (
    <section id={sectionId} data-testid="mining-smithing-recipes-panel" className="border border-amber-900/30 bg-zinc-950/80 p-4 rounded-sm space-y-4 scroll-mt-24">
      <div className="flex items-end justify-between gap-3">
        <div>
          <h2 className="font-cinzel text-base text-amber-300 uppercase tracking-wide">Smithing Materials</h2>
          <p className="text-xs text-zinc-500 mt-1">Craft advanced mining materials from ore, then use them on pickaxes or at the blacksmith.</p>
        </div>
        <div data-testid="mining-smithing-recipes-unlocked" className="text-xs text-zinc-400">
          {smithing?.recipes_unlocked || 0} recipe{smithing?.recipes_unlocked === 1 ? "" : "s"} unlocked
        </div>
      </div>

      {smithing?.active_boost && (
        <div data-testid="mining-active-smithing-boost" className="border border-amber-900/30 bg-amber-950/10 p-4 rounded-sm">
          <div className="text-xs uppercase tracking-[0.18em] text-amber-300">Next mining session boost ready</div>
          <div className="font-cinzel text-base text-zinc-100 mt-2">{smithing.active_boost.name}</div>
          <div className="text-xs text-zinc-400 mt-1">{smithing.active_boost.effect_summary}</div>
        </div>
      )}

      <div className="grid xl:grid-cols-2 gap-4">
        {materials.map((material) => {
          const oreCostText = Object.entries(material.ore_costs || {}).map(([rarity, amount]) => `${amount} ${rarity}`).join(" • ");
          const craftBusy = smithingBusyKey === material.id;
          const boostBusy = boostBusyKey === material.id;
          return (
            <article key={material.id} data-testid={`mining-smithing-material-${material.id}`} className="border border-zinc-800 bg-zinc-900/60 p-4 rounded-sm space-y-4">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="font-cinzel text-base text-zinc-100">{material.name}</div>
                  <div className="text-xs uppercase tracking-[0.18em] text-zinc-500 mt-1">{material.category.replaceAll("_", " ")}</div>
                </div>
                <div data-testid={`mining-smithing-count-${material.id}`} className="text-xs text-zinc-400">Owned: <span className="text-zinc-100">{material.count}</span></div>
              </div>

              <div className="text-xs text-zinc-400">{material.description}</div>
              <div className="text-xs text-zinc-300">{material.effect_summary}</div>

              <div className="border border-zinc-800 bg-zinc-950/50 p-3 rounded-sm text-xs text-zinc-400">
                Craft cost: <span data-testid={`mining-smithing-cost-${material.id}`} className="text-zinc-100">{oreCostText}</span>
              </div>

              {!material.unlocked ? (
                <div data-testid={`mining-smithing-locked-${material.id}`} className="text-xs uppercase tracking-[0.18em] text-zinc-500">
                  Unlock by claiming {material.unlock_discovery_name} milestone {material.unlock_milestone}
                </div>
              ) : (
                <div className="flex flex-wrap gap-2">
                  <button
                    data-testid={`mining-smithing-craft-${material.id}`}
                    onClick={() => onCraft(material)}
                    disabled={craftBusy}
                    className="px-4 py-2 border border-amber-600 text-amber-300 hover:bg-amber-950/20 rounded-sm text-xs font-cinzel uppercase tracking-[0.18em] disabled:opacity-50"
                  >
                    {craftBusy ? "Crafting" : "Craft 1"}
                  </button>
                  {material.category === "mining_boost" && (
                    <button
                      data-testid={`mining-smithing-activate-${material.id}`}
                      onClick={() => onActivateBoost(material)}
                      disabled={boostBusy || material.count <= 0}
                      className="px-4 py-2 border border-zinc-700 text-zinc-200 hover:bg-zinc-800/70 rounded-sm text-xs font-cinzel uppercase tracking-[0.18em] disabled:opacity-50"
                    >
                      {boostBusy ? "Activating" : "Prime Next Session"}
                    </button>
                  )}
                </div>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
};